import { WorkspaceResourceType } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import getLogger, { LogGroup } from "js/core/logger";
import withProgressDialog from "js/core/utilities/withProgressDialog";
import { t } from "js/i18n";
import { ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";

const logger = getLogger(LogGroup.TEAMS);

export type FolderResource = {
    resourceId: string;
    resourceType: WorkspaceResourceType;
};

type RemoveResourcesFromFolderOptions = {
    folderId: string;
    resources: FolderResource[];
    resourceLabel: string;
};

export async function removeResourcesFromFolder({
    folderId,
    resources,
    resourceLabel,
}: RemoveResourcesFromFolderOptions) {
    if (!resources.length) {
        return;
    }

    const resourceFolder = WorkspaceController.resourceFolders.find(folder => folder.id === folderId);
    const folderName = resourceFolder?.name ?? t("folder");

    await withProgressDialog({
        title: resources.length === 1
            ? t("Removing {{resourceLabel}} from {{folderName}}...", { resourceLabel, folderName })
            : t("Removing {{count}} {{resourceLabel}} from {{folderName}}...", {
                count: resources.length,
                resourceLabel,
                folderName,
            }),
        action: async () => {
            try {
                await WorkspaceController.updateWorkspaceResourceFolderResources({
                    folderId,
                    update: {
                        remove: resources,
                    },
                });
            } catch (err) {
                // Intentionally handle errors here so this helper remains fire-and-forget for current UI call sites.
                logger.error(err, "[removeResourcesFromFolder] failed", { folderId });

                ShowErrorDialog({
                    title: t("Unable to remove from folder"),
                    message: (err as Error).message,
                });
            }
        },
    });
}
